module.exports = __webpack_public_path__ + "media/markers/marker-green-1124c43f.svg";